// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Checkmark-module--bx--text-truncate--end--Zu3lg";
export var bxTextTruncateFront = "Checkmark-module--bx--text-truncate--front--0rRii";
export var drawStroke = "Checkmark-module--drawStroke--yI-G+";
export var path = "Checkmark-module--path--C9Wgb";
export var svg = "Checkmark-module--svg--VqnLR";